// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"17e20f02","779":"e6124182","908":"fcca4431"}[chunkId] + ".chunk.js";
};